import{useEffect as n}from"react";function o(o,f,t){n((function(){if(o){var n=function(n){t&&t(o,n)};return o.on(f,n),function(){o.off(f,n)}}}),[o,f,t])}export{o as useEvent};
